<script setup lang="ts">
import type { HTMLAttributes } from 'vue'

import { cn } from '#ui/utils'

const props = defineProps<{
  class?: HTMLAttributes['class']
}>()
</script>

<template>
  <div
    data-slot="alert-description"
    :class="
      cn(
        'text-sm text-balance text-muted-foreground md:text-pretty [&_a]:underline [&_a]:underline-offset-3 [&_a]:hover:text-foreground [&_p:not(:last-child)]:mb-4',
        props.class,
      )
    "
  >
    <slot />
  </div>
</template>
